import { render, staticRenderFns } from "./project-pictogram.vue?vue&type=template&id=38d0eea0"
import script from "./project-pictogram.vue?vue&type=script&lang=js"
export * from "./project-pictogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports